var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "log_out",
    "data-name": "log out",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(-0.897 -0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30858",
    "data-name": "Path 30858",
    d: "M14.549,19.427h-.117c-4.007,0-5.938-1.508-6.272-4.885a.656.656,0,0,1,.614-.706.677.677,0,0,1,.74.586c.262,2.705,1.6,3.713,4.927,3.713h.117c3.673,0,4.973-1.241,4.973-4.747V7.77c0-3.507-1.3-4.747-4.973-4.747H14.44c-3.348,0-4.684,1.025-4.927,3.782a.671.671,0,0,1-.74.586.657.657,0,0,1-.623-.7C8.457,3.264,10.4,1.73,14.431,1.73h.117c4.431,0,6.326,1.809,6.326,6.04v5.617C20.875,17.617,18.98,19.427,14.549,19.427Z",
    transform: "translate(1.188 1.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30859",
    "data-name": "Path 30859",
    d: "M13.655,12.615H1.933a.683.683,0,1,1,0-1.365H13.655a.683.683,0,1,1,0,1.365Z",
    transform: "translate(2.646 0.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30860",
    "data-name": "Path 30860",
    d: "M12.6,15.583a.7.7,0,0,1-.5-.206.707.707,0,0,1,0-.993l2.642-2.642L12.106,9.1a.7.7,0,0,1,.993-.993l3.139,3.139a.707.707,0,0,1,0,.993L13.1,15.377A.7.7,0,0,1,12.6,15.583Z",
    transform: "translate(0.812 0.489)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8477",
    "data-name": "Rectangle 8477",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogout);
export default __webpack_public_path__ + "static/media/menu-logout.951e0f6d8b37fbcf9fa241968844d47b.svg";
export { ForwardRef as ReactComponent };